import { Environment } from './environment';

const servers = [
    { name: 'Development', key: Environment.Staging },
    { name: 'Testing', key: Environment.Testing },
    { name: 'Production', key: Environment.Production }
];

export default servers;